import {
  GatewayConformite,
  GatewayControleQuinquennal,
} from "@conformite/gateway";

/**
 * MR-G — Mapping axe de conformité assujetti (enum front, dont la valeur
 * historique `FORME_CONTINUE_IAS`) → dimension de sous-axe gateway (clé de la
 * ligne de vérification `<assujettiId>:<DIMENSION>`).
 *
 * Mapping NOUVEAU et DISTINCT de `axeConformiteToQuestionnaireSlug`
 * (avancement.helper.ts) : ce dernier et son miroir gateway doivent rester sans
 * entrée LISTE/ASSUJETTI — ne rien y ajouter.
 */
const axeConformiteToDimension: Partial<
  Record<
    GatewayConformite.AxeConformite,
    GatewayControleQuinquennal.ControleQuinquennalDimension
  >
> = {
  [GatewayConformite.AxeConformite.HONORABILITE]: "HONORABILITE",
  [GatewayConformite.AxeConformite.CAPACITE_PRO_IAS]: "CAPACITE_PRO_IAS",
  [GatewayConformite.AxeConformite.CAPACITE_PRO_IOBSP]: "CAPACITE_PRO_IOBSP",
  [GatewayConformite.AxeConformite.FORMATION_CONTINUE_IAS]:
    "FORMATION_CONTINUE_IAS",
  [GatewayConformite.AxeConformite.FORMATION_CONTINUE_IOBSP]:
    "FORMATION_CONTINUE_IOBSP",
};

/** Clé `subAxis` du sous-axe d'axe « liste des assujettis ». */
export const LISTE_ASSUJETTIS_SUBAXIS = "LISTE";

/**
 * Clé `subAxis` (`'<assujettiId>:<DIMENSION>'`) de la carte personne ×
 * dimension, ou undefined si l'axe n'est pas une dimension assujetti.
 */
export function getSubAxisForAxe(
  assujettiId: string,
  axe: GatewayConformite.AxeConformite
): string | undefined {
  const dimension = axeConformiteToDimension[axe];
  if (!dimension) return undefined;
  return `${assujettiId}:${dimension}`;
}
